export default "__VITE_ASSET__DgGPlMXa__"